import PropTypes from 'prop-types';
import './SurveyQuizSelect.css';
import QuizButton from '../../../../Details/components/Quiz/QuizButton';

export default function QuizSelect({
  options,
  handler,
  btnClass,
  value,
  surveyQuiz,
  layout = 'row',
}) {
  return (
    <div
      className={`surveyQuizSelect ${layout}`}
      role="group"
      aria-label="quiz options"
    >
      {options.map((option, i) => (
        <QuizButton
          key={`quiz_select_btn_${i}_${option}`}
          option={option}
          index={i}
          onClickEvent={handler}
          btnClass={btnClass}
          selected={Boolean(value && option.toLowerCase() === value)}
          surveyQuiz={surveyQuiz}
          noMargin
        />
      ))}
    </div>
  );
}

QuizSelect.propTypes = {
  options: PropTypes.array.isRequired,
  handler: PropTypes.func.isRequired,
  btnClass: PropTypes.string,
  value: PropTypes.string, 
  surveyQuiz: PropTypes.any,
  layout: PropTypes.oneOf(['row', 'pyramid']),
};
